<div class="grid-t4s-wrap">
    <ul class="grid-product-wrap--4S">
        <li class="grid-product-list--4S" *ngFor="let product of products">
            <product-view
                class="p-view"
                [productId]="product"
                [config]="templateConfiguration$ | async"
                [categoryConfig]="categoryConfiguration"
                [productStyle]="productStyle"
                [defaultImageType]="elementDefaultImageTypes?.[product]"
                (clickActionBadge)="addToCartSheet($event)"
            ></product-view>
        </li>
    </ul>
</div>
